import React from "react"
import PropTypes from "prop-types"
import { useFormInfo, useEditingContext } from "app/forms/data/form-data"
import { FormStyle } from "./form-style"

export const Form = props => {
  const { preview = false, children, style } = props
  const editing = useEditingContext()
  const Tag = preview ? "div" : "form"

  const {
    action,
    id,
    uid,
    ckjsVersion,
    templateComponent: template,
    template: { format }
  } = useFormInfo()

  return (
    <Tag
      action={action}
      style={style}
      className="seva-form formkit-form"
      method="post"
      data-sv-form={id}
      data-uid={uid}
      data-format={editing ? `${format}-editing` : format}
      data-version={ckjsVersion}
      data-options={props["data-options"]}
      min-width="400 500 600 700 800"
    >
      {children}
      <FormStyle
        scope={`.formkit-form[data-uid="${uid}"]`}
        template={template}
      />
    </Tag>
  )
}

Form.propTypes = {
  children: PropTypes.any,
  preview: PropTypes.bool,
  settings: PropTypes.object,
  template: PropTypes.func,
  style: PropTypes.object,
  "data-options": PropTypes.any
}
